<template>
	<div class="card custom-card">
		<div class="card-header typo-h5 d-flex align-items-center">
			<span>EC Code</span>
			<CBadge
				v-if="badge.title"
				:color="badge.color"
				class="badge-ec-code-status"
				data-test-id="badge-ec-code-status"
			>
				{{ badge.title }}
			</CBadge>
			<CButton
				v-if="isShowRetryButton"
				color="secondary"
				class="ml-auto"
				data-test-id="btn-retry-redeem-ec-code"
				:disabled="isSubmitting"
				@click="$refs['modal-confirm-retry-redeem'].open()"
			>
				Redeem EC Code อีกครั้ง
			</CButton>
		</div>
		<div class="card-body">
			<CRow>
				<CCol>
					<h6>
						EC Code
					</h6>
					<div v-if="ecCode" class="order-meta">
						EC Code: <span class="order-meta-value">{{ ecCode }}</span>
					</div>
					<div v-if="university" class="order-meta">
						University: <span class="order-meta-value">{{ university }}</span>
					</div>
					<div v-if="ecRedeemedAt" class="order-meta">
						Redeemed at: <span class="order-meta-value">{{ ecRedeemedAt }}</span>
					</div>
				</CCol>
			</CRow>
		</div>

		<ModalConfirmRetryRedeemECCode
			ref="modal-confirm-retry-redeem"
			:ec-code="ecCode"
			:is-submitting="isSubmitting"
			@onConfirm="handleRetryRedeem"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ModalConfirmRetryRedeemECCode from '@/components/ModalConfirmRetryRedeemECCode.vue';
import isHavePermissionMixins from '../mixins/isHavePermission';
import {
	ORDER_EC_REDEEMED_TITLE,
	ORDER_EC_REDEEMED_COLOR,
} from '../enums/orders';

export default {
	name: 'OrderDetailECCode',
	components: {
		ModalConfirmRetryRedeemECCode,
	},
	mixins: [isHavePermissionMixins],
	props: {
		orderId: {
			type: Number,
			default: 0,
		},
		ecCode: {
			type: String,
			default: '',
		},
		university: {
			type: String,
			default: '',
		},
		ecRedeemedStatus: {
			type: String,
			default: null,
		},
		ecRedeemedAt: {
			type: String,
			default: null,
		},
		// BE เป็นคนตัดสินว่ากดซ้ำได้ไหม (can_retry_redeem_ec_code) - ห้ามคำนวณเงื่อนไขเองที่ FE
		canRetryRedeem: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState('orders', {
			redeemEcCode: 'redeemEcCode',
		}),
		isSubmitting() {
			return this.redeemEcCode.isSubmitting;
		},
		badge() {
			return {
				title: ORDER_EC_REDEEMED_TITLE.ORDER[this.ecRedeemedStatus] || null,
				color: ORDER_EC_REDEEMED_COLOR.ORDER[this.ecRedeemedStatus] || 'alto',
			};
		},
		isShowRetryButton() {
			return this.canRetryRedeem && this.hasEditPermission;
		},
	},
	methods: {
		...mapActions({
			redeemEcCodeAction: 'orders/redeemEcCode',
		}),
		async handleRetryRedeem() {
			if (!this.orderId) {
				return;
			}

			// action จัดการ toast ทั้งเคสสำเร็จและเคส Apple ปฏิเสธเองแล้ว
			// รวมถึงโหลด order ใหม่ - ปิด modal ได้เลยไม่ว่าผลจะเป็นอะไร
			await this.redeemEcCodeAction({ id: this.orderId });

			this.$refs['modal-confirm-retry-redeem'].close();
		},
	},
};
</script>

<style lang="scss" scoped>
	.order-meta {
		@include typo-body-2;

		color: $color-black-45;

		// order-meta-value
		&-value {
			color: $color-black-90;
		}
	}

	.badge-ec-code-status {
		width: auto;
		padding: rem(7) rem(8);
		margin-left: rem(16);
		font-size: rem(14);
	}
</style>
